import React from 'react'

const SmallHeading = ({data}) => {
    return <h2 className="commonSmallHeading">{data}</h2>;
}

export default SmallHeading